<template>
  <div class="videoplay">
    <el-dialog
      :visible.sync="videoplay"
      :modal-append-to-body="false"
      :before-close="colsevideo"
    >
      <div>
        <div class="header-wrap">
          <div class="title">
            <i class="el-icon-success"></i>
            <span>语音生成成功</span>
          </div>
          <!-- <div class="text-gray">作品有效期1天，分享到朋友圈集赞送会员哦</div> -->
        </div>
        <div class="videobox">
          <audio controls>
            <source :src="audioUrl" >
          </audio>
        </div>

        <div class="btn-wrap">
          <div class="share-btn-wrap flex-center">
            <!-- <div class="btn-share flex-center">
              <span>扫码分享</span>
            </div> -->
          </div>
          <!-- <div class="tips">
            推荐使用「<a
              href="https://www.animiz.cn/videoclipmaster/?wancaiai"
              target="_blank"
              >康桥特效大师</a
            >」，一键去除视频背景
          </div> -->
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
var time
import {videoQuery} from "@/api/video"
export default {
  props:{
    audioUrl:{
        default:"",
    }
  },
  data() {
    return {
      audioUrl:"",
      share:false,
      videoplay: true,
    };
  },
  mounted() {
  },
  methods: {
    colsevideo() {
      this.$emit("colsevideo");
    },
  },
};
</script>

<style lang="less">
.videoplay {
  .header-wrap {
    text-align: center;
    padding-top: 20px;
    i {
      color: #38b865;
    }
    .title {
      font-size: 22px;
      font-weight: 700;
      margin-bottom: 10px;
    }
    .text-gray {
      color: #999;
      font-size: 14px;
    }
  }
  .videobox {
    overflow: hidden;
    border-radius: 8px;
    background-color: #f4f5f7;
    margin: 20px 32px 0;
    box-sizing: border-box;
    audio {
      width: 100%;
      display: block;
    }
  }

  .btn-wrap{
    padding: 32px 0 16px;
    .share-btn-wrap{
      display: flex;
      justify-content: center;
      .btn-share{
        display: inline-flex;
        width: 185px;
        height: 50px;
        font-size: 18px;
        border-radius: 8px;
        background: #f4f5f7;
        vertical-align: bottom;
        cursor: pointer;
        position: relative;
        justify-content: center;
        align-items: center;
      }
      .btn-down{
        width: 185px;
        height: 50px;
        border-radius: 8px;
        font-size: 18px;
        font-weight: 700;
        background-image:linear-gradient(106.92deg, rgb(16, 197, 254) 14.83%, rgb(16, 147, 254) 31.52%, rgb(79, 79, 231) 65.11%, rgb(182, 12, 185) 91.29%, rgb(224, 202, 245) 102.83%);
        color: #fff;
        justify-content: center;
        align-items: center;
        display: inline-flex;
        margin-left: 32px;
      }
    }
    .tips{
      margin-top: 8px;
      color: #999;
      font-size: 12px;
      text-align: center;
    }
  }
}
@media (max-width:1000px) {
  .videoplay{
    .el-dialog{
      width: 80%;
      // height: 626px!important;
    }
    .videobox{
      margin:0;
    }
  }
}
</style>